// extracted by mini-css-extract-plugin
export default {"link":"Help_link__fYT9T"};